// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1-i3K","content":"LoadingAlert_content___8NYl"};